module.exports = __webpack_public_path__ + "img/customer-logo.a3ca13f8_1.0.18.svg";